module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/4b6e45367d8faa5bf16040c8a93cfd58.png";